module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_memebox.e97aa17cb6b47f19489bb13485da9ccf.png";